import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
  /**
   * 导出excel
   * @param {*} table 
   * @param {*} filename 
   */
  excel(table, filename = 'excel') {
    const wb = XLSX.utils.table_to_book(table, {
      raw: true // 原样导出，不转换
    });
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array'
    });
    try {
      FileSaver.saveAs(new Blob([wbout], {
        type: 'application/octet-stream'
      }), `${filename}.xlsx`)
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout)
    }
    return wbout
  }
}